import { render, staticRenderFns } from "./render.vue?vue&type=template&id=128f5eb1&scoped=true"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"
import style0 from "./render.vue?vue&type=style&index=0&id=128f5eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f5eb1",
  null
  
)

export default component.exports